import layout from '@/views/layout/layout.vue'
const productList = r => require.ensure([], () => r(require('@/views/jinluxin/product/list.vue')), 'group-jinluxin-product')

const jinluxinProduct = [
  {
    path: '/jinluxin/product',
    name: 'products-product',
    component: layout,
    redirect: '/jinluxin/product/list',
    children: [
      {
        path: 'list',
        name: 'jinluxin-product-list',
        component: productList,
        meta: {
          displayName: '产品管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default jinluxinProduct



// WEBPACK FOOTER //
// ./src/router/jinluxin/product.js